import { defineComponent as _defineComponent } from 'vue';
import { unref as _unref, createElementVNode as _createElementVNode, createTextVNode as _createTextVNode, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, toDisplayString as _toDisplayString, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue";
const _withScopeId = (n) => (_pushScopeId("data-v-72eecc17"), n = n(), _popScopeId(), n);
const _hoisted_1 = { class: "footer" };
const _hoisted_2 = { class: "site-container footer-top" };
const _hoisted_3 = { class: "footer-brand" };
const _hoisted_4 = ["src"];
const _hoisted_5 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/ _createElementVNode("div", null, [
    /*#__PURE__*/ _createElementVNode("strong", null, "Mary Iglesias"),
    /*#__PURE__*/ _createElementVNode("span", null, "Escribana Pública")
], -1));
const _hoisted_6 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/ _createElementVNode("p", { class: "footer-statement" }, [
    /*#__PURE__*/ _createTextVNode("Tu consulta, explicada con claridad."),
    /*#__PURE__*/ _createElementVNode("br"),
    /*#__PURE__*/ _createTextVNode("Tu gestión, cuidada de principio a fin.")
], -1));
const _hoisted_7 = { class: "site-container footer-grid" };
const _hoisted_8 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/ _createElementVNode("span", null, "Estudio", -1));
const _hoisted_9 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/ _createElementVNode("br", null, null, -1));
const _hoisted_10 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/ _createElementVNode("div", null, [
    /*#__PURE__*/ _createElementVNode("span", null, "Contacto"),
    /*#__PURE__*/ _createElementVNode("a", { href: "tel:+59899943824" }, "+598 99 943 824"),
    /*#__PURE__*/ _createElementVNode("a", { href: "mailto:maryiglesiassosa@gmail.com" }, "maryiglesiassosa@gmail.com")
], -1));
const _hoisted_11 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/ _createElementVNode("span", null, "Secciones", -1));
const _hoisted_12 = ["onClick"];
const _hoisted_13 = { class: "site-container footer-bottom" };
const _hoisted_14 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/ _createElementVNode("p", null, "Atención con agenda previa", -1));
import { nextTick } from 'vue';
import { useRoute, useRouter } from 'vue-router';
const mapUrl = 'https://www.google.com/maps/search/?api=1&query=Bulevar+Espa%C3%B1a+2059%2C+Montevideo%2C+Uruguay';
export default /*#__PURE__*/ _defineComponent({
    __name: 'Footer',
    setup(__props) {
        const logo = new URL('@/assets/notarial-logo.png', import.meta.url).href;
        const currentYear = new Date().getFullYear();
        const navItems = [
            { label: 'Servicios', id: 'services-section', route: '' },
            { label: 'Propiedades', id: '', route: 'properties' },
            { label: 'Sobre mí', id: 'about-section', route: '' },
            { label: 'Contacto', id: 'contact-form', route: '' },
        ];
        const router = useRouter();
        const route = useRoute();
        const navigate = async (item) => {
            if (item.route) {
                await router.push({ name: item.route });
                return;
            }
            if (route.name !== 'home')
                await router.push({ name: 'home' });
            await nextTick();
            document.getElementById(item.id)?.scrollIntoView({ behavior: 'smooth', block: 'start' });
        };
        return (_ctx, _cache) => {
            return (_openBlock(), _createElementBlock("footer", _hoisted_1, [
                _createElementVNode("div", _hoisted_2, [
                    _createElementVNode("div", _hoisted_3, [
                        _createElementVNode("img", {
                            src: _unref(logo),
                            alt: ""
                        }, null, 8, _hoisted_4),
                        _hoisted_5
                    ]),
                    _hoisted_6
                ]),
                _createElementVNode("div", _hoisted_7, [
                    _createElementVNode("div", null, [
                        _hoisted_8,
                        _createElementVNode("a", {
                            href: mapUrl,
                            target: "_blank",
                            rel: "noopener noreferrer"
                        }, [
                            _createTextVNode(" Bulevar España 2059, apto. 104"),
                            _hoisted_9,
                            _createTextVNode("esquina Blanes · Montevideo ")
                        ])
                    ]),
                    _hoisted_10,
                    _createElementVNode("div", null, [
                        _hoisted_11,
                        (_openBlock(), _createElementBlock(_Fragment, null, _renderList(navItems, (item) => {
                            return _createElementVNode("button", {
                                key: item.label,
                                type: "button",
                                onClick: ($event) => (navigate(item))
                            }, _toDisplayString(item.label), 9, _hoisted_12);
                        }), 64))
                    ])
                ]),
                _createElementVNode("div", _hoisted_13, [
                    _createElementVNode("p", null, "© " + _toDisplayString(_unref(currentYear)) + " Estudio Notarial Mary Iglesias", 1),
                    _hoisted_14
                ])
            ]));
        };
    }
});
